import { Box, Button, Center, Checkbox, Divider, Flex, FormControl, HStack, Image, Input, InputGroup, InputRightElement, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Stack, Tab, TabList, TabPanel, TabPanels, Tabs, Text, useDisclosure, useToast } from '@chakra-ui/react'
import { useFormik } from 'formik'
import React, { ChangeEvent, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Adminroutes from '../routes'

import { RiSearch2Line } from 'react-icons/ri'
import delete_vector from "../../../img/deleteVector.svg"
import share_vector from "../../../img/shareVector.svg"
import { IGetSurveyQuestions } from '../../../models/admin/Survey.model'
import { IUserProfile } from '../../../models/admin/user.model'
import { ICenter } from '../../../models/centers.model'
import { IAvailableCourse } from '../../../models/trainee-course.model'
import AdminHelpers from '../../../services/admin/admin.service'
import SurveyService from '../../../services/admin/survey.service'
import { getLocalUserProfile } from '../../../services/auth.service'
import coursesService from '../../../services/courses.service'


export const CreateSurvey = ({each}:any) => {
    const navigate = useNavigate();
    const toast = useToast();
    const [questionList, setQuestionList] = useState<IGetSurveyQuestions | any>([]);
    const [filteredQuestionList, setFilteredQuestionList] = useState<IGetSurveyQuestions | any>([]);
    const [isSearchEmpty, setIsSearchEmpty] = useState(false);
    const [addedQuestions, setAddedQuestions] = useState<any>([]);
    const [questionIdArray, setQuestionIdArray] = useState<any>([]);
    const [templateStatus, setTemplateStatus] = useState(true);
    const [loading, setLoading] = useState(true);
    // const [templateCode, setTemplateCode] = useState('');
    const [focus, setFocus] = useState('');
    const [courseId, setCourseId] = useState('');
    const [trainerId, setTrainerId] = useState('');
    const [centerId, setCenterId] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [courses, setCourses] = useState<IAvailableCourse | any>([]);
    const [trainers, setTrainers] = useState<IUserProfile | any>([]);
    const [centers, setCenters] = useState<ICenter | any>([]);
    const [isChecked, setIsChecked] = useState(false);
    const user: any = getLocalUserProfile();
    const { isOpen: isCustomOpen, onOpen: onCustomOpen, onClose: onCustomClose } = useDisclosure();
    const { isOpen: isSurveyOpen, onOpen: onSurveyOpen, onClose: onSurveyClose } = useDisclosure()
    const { isOpen, onOpen, onClose } = useDisclosure()
    const initialRef = React.useRef(null)
    const finalRef = React.useRef(null)

    useEffect(() => {
        SurveyService.getSurveyQuestions().then(
            (res) => {
                setQuestionList(res.data);
                setFilteredQuestionList(res.data);
                setLoading(false);
                // 
            }
        )
        coursesService.getAvailableCourses().then(
            (res) => {
                setCourses(res);
            }
        )
        AdminHelpers.getTrainers().then(
            (res) => {
                setTrainers(res.data);
                // 
            }
        )
        AdminHelpers.getAllCenters().then(
            (res) => {
                setCenters(res.data);
                // 
            }
        )
        
        // setAddedQuestions(questionList.filter((object: any) => questionIdArray.includes(object.id.toString())));
    }, []);

    // handle create survey
    const handleCreateSurvey = async () => {
        const templateDetails: any = {
            survey_question_ids: questionIdArray,
            created_by: user?.uuid,
            name: "",
            description: "",
        }
        const surveyTemplateResponse = await SurveyService.createSurveyTemplate(templateDetails)
        if (surveyTemplateResponse.status == "success"){
            
            try {
                    toast({
                        title: "Survey Template",
                        description: "Survey Template created successfully",
                        status: "success",
                    })
                    navigate(Adminroutes.Survey)

                // }
            } catch (error: any) {
                
                toast({
                    title: "Survey",
                    description: `${error.response.data.message}`,
                    status: "error",
                })
            }
        }
    }

    const handleSearchChange = (event: ChangeEvent<HTMLInputElement>) => {
        const searchTerm = event.target.value.toLowerCase();
        
        if (!searchTerm) {
            setFilteredQuestionList(questionList);
        } else if (searchTerm) {
            if (questionList) {
                const filtered = questionList.filter((each: any) => each.question.toLowerCase().includes(searchTerm) );
                setFilteredQuestionList(filtered);
            }
        }
    }

    const handleCheckbox = (e: ChangeEvent<HTMLInputElement>) => {
        setIsChecked(!isChecked);
        const { value, checked } = e.target;
        if (checked) {
            setQuestionIdArray([...questionIdArray, value])
        } else {
            setQuestionIdArray(questionIdArray.filter((id: any) => id! == value))
        }
    }

    const handleAdd = () => {
        
        onClose();
        setAddedQuestions(filteredQuestionList.filter((object: any) => questionIdArray.includes(object.id.toString())));
    }

    const handleRemoveQuestion = (uuid: string, id:number) => {
        const index = questionIdArray.indexOf(id.toString());
        if (index > -1) {
            questionIdArray.splice(index, 1);
        }
        toast({
            title: "Create Survey",
            description: "Question removed successfully",
            status: "success",
        });
        setAddedQuestions(questionList.filter((object: any) => questionIdArray.includes(object.id.toString())));
        
    }

    const handleDeleteQuestion = (uuid: string) => {
        if (uuid) {
            SurveyService.deleteSurveyQuestion(uuid).then(
                (res) =>{
                    
                    toast({
                        title: "Question",
                        description: "Question removed successfully",
                        status: "success",
                    });
                }
            )
            SurveyService.getSurveyQuestions().then(
                (res) => {
                    setQuestionList(res.data);
                }
            )
        }

    }
    
    const handleCreateSurveyQuestion = () => {
        onClose();
        SurveyService.getSurveyQuestions().then(
            (res) => {
                setQuestionList(res.data);
                onCustomOpen();
            }
        )
    }
    const formik = useFormik({
        validate: (values: any) => {
            const errors: any = {};
            return errors;
        },
        initialValues: {
            question: '',
            question_answer_type: "labels",
            label1: 'Horrible',
            label2: 'Excellent',
            label3: '',
            label4: '',
            created_by: user?.id.toString(),
        },
        onSubmit: async (values) => {
            const surveyQuestionSet: any = {
                question: values.question,
                question_answer_type: "labels",
                label1: values.label1,
                label2: values.label2,
                label3: '1',
                label4: '5',
                created_by: user?.id.toString(),

            }
            
            try {
                const basicResponse = await SurveyService.postSurveyQuestion(surveyQuestionSet);
                if (basicResponse) {
                    onCustomClose()
                    formik.resetForm()
                    onOpen()
                    SurveyService.getSurveyQuestions().then(
                        (res) => {
                            setFilteredQuestionList(res.data);
                        }
                    )
                    toast({
                        title: "Survey",
                        description: "Question created successfully",
                        status: "success",
                    })

                }
            } catch (error: any) {
                
                toast({
                    title: "Survey",
                    description: `${error.response.data.message}`,
                    status: "error",
                })
            }
        }
    })

    return (
        <>
            <Flex bg="white" height="65px" width="100hw" justifyContent="flex-end" alignItems="center" px="2rem" direction="row" >
                    {/* <Input placeholder='Enter Survey Title' size='md' border='none' width="25%" variant="unstyled" /> */}
                    {/* <HStack spacing="1.2rem" fontSize="14px" color="red">
                        <Link to={Adminroutes.Survey}>Exit</Link>
                    </HStack> */}
                <Flex bg="white" fontSize="14px" height="65px" width="100hw" justifyContent="flex-end" alignItems="center" px="2rem" direction="row" gap="1rem">
                    <Text as="button" onClick={() => navigate(Adminroutes.Survey)} color="red">Exit</Text>
                    <Button colorScheme="red"
                        borderRadius="4px"
                        fontSize="13px"
                        fontWeight="600"
                        onClick={() => handleCreateSurvey()}
                        // disabled={templateStatus}
                    >Create Template
                    </Button>
                </Flex>
            </Flex>
            <Center bg="#F9F8F8" width="100hw" minHeight="90vh">
                <Tabs isLazy bg="white" width="70%" mt={50} mb="100px" height="auto" colorScheme="red">
                    <TabList width="full" display="flex" justifyContent="center" alignItems="center">
                        <Tab fontWeight="700" fontSize="16px">Survey Questions</Tab>
                        {/* <Tab  fontWeight="700" fontSize="16px">Trainees Response</Tab> */}
                    </TabList>
                    <TabPanels>
                        <TabPanel display="flex" flexDirection="row" padding="1rem" width="100%" justifyContent="center">
                            <Flex width="80%" direction="column" justifyContent="center" alignItems="center" height="auto" gap="2.4rem" paddingBottom="3rem">
                                {
                                    addedQuestions.length > 0 ?

                                        addedQuestions?.map((each: any, index: number) => (
                                            <Box key={index} width="85%" height="auto" mt="3rem" borderColor="#9E9E9E" borderRadius="8px" borderWidth="0.3px" px="2.5rem" py="1.4rem">
                                                <HStack spacing="8px">
                                                    <Text>{index + 1}.</Text>
                                                    <Text width="100%"
                                                        fontWeight="500"
                                                        fontSize="16px"
                                                        lineHeight="22px">{each.question}</Text>
                                                </HStack>
                                                <Flex justifyContent="space-between" mt="1.6rem">
                                                    <Stack spacing="14px">
                                                        <HStack fontSize="14px">
                                                            <Text>1.</Text>
                                                            <Text>{each.label1}</Text>
                                                        </HStack>
                                                        <HStack fontSize="14px">
                                                            <Text>5.</Text>
                                                            <Text>{each.label2}</Text>
                                                        </HStack>
                                                    </Stack>
                                                </Flex>
                                                <Divider mt="1.4rem" />
                                                <Flex justifyContent="flex-end" direction="row" alignItems="center" mt="0.8rem" fontSize="14px" onClick={() => handleRemoveQuestion(each.uuid, each.id)}>
                                                    <Image src={delete_vector} height="35px" width="35px" cursor="pointer" />
                                                    <Text cursor="pointer">Delete</Text>
                                                </Flex>
                                            </Box>
                                        ))
                                        :
                                        <Box width="85%" height="14rem" margin="0px" display="flex" justifyContent="center" alignItems="center"  mt="3rem" borderColor="#9E9E9E" borderWidth="0.3px" borderRadius="8px" px="2.5rem" py="1.4rem">
                                            <Button colorScheme="red" borderRadius="4px" fontSize="13px" fontWeight="600" type="submit" onClick={onOpen}>
                                                Add Question
                                            </Button>
                                        </Box>
                                }
                                {
                                    addedQuestions.length > 0 ?
                                        <Flex justifyContent="flex-end" alignItems="center" width="full">
                                            <Button colorScheme="red" borderRadius="4px" fontSize="13px" fontWeight="600" type="submit" onClick={onOpen}>
                                                Add Question
                                            </Button>
                                            {/* <Button colorScheme="red" borderRadius="0px" fontSize="13px" fontWeight="600" type="submit" onClick={() => handleSurveySubmit()}>
                                                Create Template
                                            </Button> */}
                                        </Flex> : ""
                                }
                                <Modal
                                    initialFocusRef={initialRef}
                                    finalFocusRef={finalRef}
                                    isOpen={isOpen}
                                    onClose={onClose}
                                >
                                    <ModalOverlay />
                                    <ModalContent minWidth="800px" width="auto">
                                        <ModalHeader>Add Question</ModalHeader>
                                        <ModalCloseButton colorScheme="red" />
                                        <ModalBody pb={6}>
                                            <InputGroup color="brand.subtitle" bg="white" width="100%" borderRadius='12px' pb='1rem'>
                                                <Input height='3rem' placeholder="Search for keywords" onChange={e => handleSearchChange(e)} fontSize={14} size="sm" />
                                                <InputRightElement cursor='pointer' pointerEvents="none" children={<RiSearch2Line color="red" size="1.2rem" />} />
                                            </InputGroup>
                                            <Box overflowY={'scroll'} maxHeight="24rem" height="auto">
                                                {
                                                    loading ? "" :
                                                    questionList.length > 0 ?
                                                        filteredQuestionList?.filter((question:any)=> !addedQuestions.includes(question)).map((each: any, index: any) => (
                                                            <Box key={index}>
                                                                <HStack width="100%" justifyContent="space-between" height="4rem" padding="0.5rem 1.5rem">
                                                                    <Image src={share_vector} alt="" />
                                                                    <Text margin-left="80px" justifyContent="flex-start">{each.question}</Text>
                                                                    <HStack gap="0.2rem">
                                                                        <Checkbox height="8px" width="10px" checked={isChecked}  value={each.id} onChange={handleCheckbox}></Checkbox>
                                                                        {/* <Image onClick={() => handleDeleteQuestion(each.uuid)} src={delete_vector} height="35px" width="35px" cursor="pointer" /> */}
                                                                    </HStack>
                                                                </HStack>
                                                                <Divider mt="0.5rem" />
                                                            </Box>
                                                        )) :
                                                            <Box padding="1.4rem" overflow={'hidden'}>
                                                                <Text>No questions found. Please create custom questions</Text>
                                                            </Box>
                                                }
                                            </Box>
                                        </ModalBody>
                                        <ModalFooter display="flex" justifyContent="space-between" pb="1.5rem">
                                            <Button borderRadius="8px"
                                                onClick={() => handleCreateSurveyQuestion()}>Custom Question</Button>
                                            <Box>
                                                <Button onClick={onClose} borderRadius="8px">Cancel</Button>
                                                <Button colorScheme='red' borderRadius="8px" ml={3} onClick={() => handleAdd()}>
                                                    Add
                                                </Button>
                                            </Box>
                                        </ModalFooter>
                                    </ModalContent>
                                </Modal>
                                <Modal isOpen={isCustomOpen} onClose={onCustomClose}>
                                    <ModalOverlay />
                                    <ModalContent>
                                        <ModalHeader>Create Survey Question</ModalHeader>
                                        <ModalCloseButton />
                                        <ModalBody>
                                            <FormControl>
                                                <HStack spacing="8px">
                                                    <Input
                                                        id="question"
                                                        name="question"
                                                        placeholder='Type survey question here'
                                                        size='md'
                                                        width="100%"
                                                        borderColor="#D5D5D5"
                                                        value={formik.values.question}
                                                        onChange={formik.handleChange}
                                                        type="text"
                                                    />
                                                </HStack>
                                                <Flex justifyContent="space-between" mt="1.6rem">
                                                    <Stack spacing="14px">
                                                        <HStack fontSize="12px">
                                                            <Text>1.</Text>
                                                            <Input
                                                                id="label1"
                                                                name="label1"
                                                                variant='flushed'
                                                                placeholder='label(optional)'
                                                                value={formik.values.label1}
                                                                type="text"
                                                                onChange={formik.handleChange} />
                                                        </HStack>
                                                        <HStack fontSize="12px">
                                                            <Text>5.</Text>
                                                            <Input
                                                                id="label2"
                                                                name="label2"
                                                                variant='flushed'
                                                                placeholder='label(optional)'
                                                                value={formik.values.label2}
                                                                onChange={formik.handleChange}
                                                                type="text"
                                                            />
                                                        </HStack>
                                                    </Stack>
                                                </Flex>
                                            </FormControl>
                                        </ModalBody>
                                        <ModalFooter>
                                            <Button colorScheme='red' mr={3} onClick={onCustomClose}>
                                                Close
                                            </Button>
                                            <Button onClick={() => formik.handleSubmit()}>
                                                Create Question
                                            </Button>
                                        </ModalFooter>
                                    </ModalContent>
                                </Modal>
                            </Flex>
                            {/* <Divider orientation='vertical' borderColor="#999999" height="100%" />
                            <Box width="30%">
                                <Stack spacing="2.6rem" pl="2rem" pt="2rem" pb="2rem" fontSize="13px" fontWeight="500">
                                    <FormControl my={2}>
                                        <FormLabel>Survey Focus</FormLabel>
                                        <Select placeholder='please select an option' fontSize="14px" value={focus} onChange={(event)=>setFocus(event.target.value)}>
                                            {
                                                surveyFocusOptions.map((each: string, index: number) =>
                                                    <option key={index}>{each}</option>
                                                )
                                            }
                                        </Select>
                                    </FormControl>
                                    {
                                        focus == "course-only" ? 
                                            <FormControl my={2}>
                                                <FormLabel>Select Course</FormLabel>
                                                <Select placeholder='please select an option' fontSize="14px" value={courseId} onChange={(event) => setCourseId(event.target.value)}>
                                                    {
                                                        courses.map((each: any, index: number) =>
                                                            <option key={index} value={each.id}>{each.course.name.slice(0,32)}...</option>
                                                        )
                                                    }
                                                </Select>
                                            </FormControl>
                                            : ""
                                    }
                                    {
                                        focus == "trainer-only" ? 
                                            <FormControl my={2}>
                                                <FormLabel>Select Trainer</FormLabel>
                                                <Select placeholder='please select an option' fontSize="14px" value={trainerId} onChange={(event) => setTrainerId(event.target.value)}>
                                                    {
                                                        trainers.map((each: any, index: number) =>
                                                            <option key={index} value={each.id}>{each.name}</option>
                                                        )
                                                    }
                                                </Select>
                                            </FormControl>
                                            : ""
                                    }
                                    {
                                       focus == "centre-only" ? 
                                            <FormControl my={2}>
                                                <FormLabel>Select Training Centre</FormLabel>
                                                <Select placeholder='please select an option' fontSize="14px" value={centerId} onChange={(event) => setCenterId(event.target.value)}>
                                                    {
                                                        centers.map((each: any, index: number) =>
                                                            <option key={index} value={each.id}>{each.name}</option>
                                                        )
                                                    }
                                                </Select>
                                            </FormControl>
                                            : ""
                                    }
                                    {
                                       focus == "center and trainer" ? 
                                            <VStack spacing="2rem">
                                                <FormControl my={2}>
                                                    <FormLabel>Select Training Center</FormLabel>
                                                    <Select placeholder='please select an option' fontSize="14px" value={centerId} onChange={(event) => setCenterId(event.target.value)}>
                                                        {
                                                            centers.map((each: any, index: number) =>
                                                                <option key={index} value={each.id}>{each.name}</option>
                                                            )
                                                        }
                                                    </Select>
                                                </FormControl>
                                                <FormControl my={2}>
                                                <FormLabel>Select Trainer</FormLabel>
                                                    <Select placeholder='please select an option' fontSize="14px" value={trainerId} onChange={(event) => setTrainerId(event.target.value)}>
                                                        {
                                                            trainers.map((each: any, index: number) =>
                                                                <option key={index} value={each.id}>{each.name}</option>
                                                            )
                                                        }
                                                    </Select>
                                                </FormControl>
                                            </VStack>
                                        : ""
                                    }
                                    {
                                        focus == "center and course" ? 
                                            <VStack spacing="2rem">
                                                <FormControl my={2}>
                                                    <FormLabel>Select Training Center</FormLabel>
                                                    <Select placeholder='please select an option' fontSize="14px" value={centerId} onChange={(event) => setCenterId(event.target.value)}>
                                                        {
                                                            centers.map((each: any, index: number) =>
                                                                <option key={index} value={each.id}>{each.name}</option>
                                                            )
                                                        }
                                                    </Select>
                                                </FormControl>
                                                <FormControl my={2}>
                                                    <FormLabel>Select Course</FormLabel>
                                                        <Select placeholder='please select an option' fontSize="14px" value={courseId} onChange={(event) => setCourseId(event.target.value)}>
                                                            {
                                                                courses.map((each: any, index: number) =>
                                                                    <option key={index} value={each.id}>{each.course.name.slice(0,32)}...</option>
                                                                )
                                                            }
                                                        </Select>
                                              </FormControl>
                                            </VStack>
                                        : ""
                                    }
                                    {
                                       focus == "trainer and course" ? 
                                            <VStack spacing="2rem">
                                                <FormControl my={2}>
                                                   <FormLabel>Select Trainer</FormLabel>
                                                    <Select placeholder='please select an option' fontSize="14px" value={trainerId} onChange={(event) => setTrainerId(event.target.value)}>
                                                        {
                                                            trainers.map((each: any, index: number) =>
                                                                <option key={index} value={each.id}>{each.name}</option>
                                                            )
                                                        }
                                                    </Select>
                                                </FormControl>
                                                <FormControl my={2}>
                                                    <FormLabel>Select Course</FormLabel>
                                                    <Select placeholder='please select an option' fontSize="14px" value={courseId} onChange={(event) => setCourseId(event.target.value)}>
                                                        {
                                                            courses.map((each: any, index: number) =>
                                                                <option key={index} value={each.id}>{each.course.name.slice(0,32)}...</option>
                                                            )
                                                        }
                                                    </Select>
                                              </FormControl>
                                            </VStack>
                                        : ""
                                    }
                                    <FormControl>
                                        <FormLabel>Start date</FormLabel>
                                        <Input
                                            placeholder="Select start date"
                                            size="md"
                                            type="datetime-local"
                                            value={startDate} 
                                            onChange={(event)=>setStartDate(event.target.value)}
                                        />
                                    </FormControl>
                                    <FormControl>
                                        <FormLabel>End date</FormLabel>
                                        <Input
                                            placeholder="Select due date"
                                            size="md"
                                            type="datetime-local"
                                            value={endDate} 
                                            onChange={(event)=>setEndDate(event.target.value)}
                                        />
                                    </FormControl>
                                    <FormControl>
                                        <FormLabel>General Instruction</FormLabel>
                                        <Textarea height="10rem" resize="none" placeholder='Enter Instruction for the survey here' />
                                    </FormControl>
                                </Stack>
                            </Box> */}
                            {/* </Flex> */}
                        </TabPanel>
                        {/* <TabPanel>
                        <VStack>
                            <Box width="80%" height="auto" mt="1rem"  px="3rem" py="1.4rem">
                                <HStack spacing="8px">
                                    <Text>1.    The entire training programme delivery and arrangement met my expectation</Text>
                                </HStack>
                                <Flex justifyContent="space-between" mt="1.6rem">
                                    <Stack spacing="14px">
                                        <HStack spacing="1.4rem">
                                            <Menu>
                                                <MenuButton
                                                    p="8px"
                                                    transition='all 0.2s'
                                                    borderRadius='sm'
                                                    borderWidth='1px'
                                                    fontSize="12px"
                                                    fontWeight="500"
                                                    bg="white"
                                                    as={Button}
                                                    rightIcon={<ChevronDownIcon />}>
                                                    1
                                                </MenuButton>
                                                <MenuList>
                                                    <MenuItem>0</MenuItem>
                                                </MenuList>
                                            </Menu>
                                            <Text>to</Text>
                                            <Menu>
                                                <MenuButton
                                                    p="8px"
                                                    transition='all 0.2s'
                                                    borderRadius='sm'
                                                    borderWidth='1px'
                                                    fontSize="12px"
                                                    fontWeight="500"
                                                    bg="white"
                                                    as={Button}
                                                    rightIcon={<ChevronDownIcon />}>
                                                    5
                                                </MenuButton>
                                                <MenuList>
                                                    <MenuItem>10</MenuItem>
                                                </MenuList>
                                            </Menu>

                                        </HStack>
                                        <HStack fontSize="12px" width="54%">
                                            <Text>1.</Text>
                                            <Input variant='filled' placeholder='Horrible' />
                                        </HStack>
                                        <HStack fontSize="12px" width="54%">
                                            <Text>5.</Text>
                                            <Input variant='filled' placeholder='Excellent' />
                                        </HStack>
                                    </Stack>
                                    <Box>
                                        <Image src={combine_ratio} alt="Test Graph"/>
                                    </Box>
                                </Flex>
                                <Divider mt="1.4rem" borderColor="#9E9E9E" borderWidth="0.1px"/>
                            </Box>
                            <Box width="80%" height="auto" mt="1rem"  px="3rem" py="1.4rem">
                                <HStack spacing="8px">
                                    <Text>1.    The entire training programme delivery and arrangement met my expectation</Text>
                                </HStack>
                                <Flex justifyContent="space-between" mt="1.6rem">
                                    <Stack spacing="14px">
                                        <HStack spacing="1.4rem">
                                            <Menu>
                                                <MenuButton
                                                    p="8px"
                                                    transition='all 0.2s'
                                                    borderRadius='sm'
                                                    borderWidth='1px'
                                                    fontSize="12px"
                                                    fontWeight="500"
                                                    bg="white"
                                                    as={Button}
                                                    rightIcon={<ChevronDownIcon />}>
                                                    1
                                                </MenuButton>
                                                <MenuList>
                                                    <MenuItem>0</MenuItem>
                                                </MenuList>
                                            </Menu>
                                            <Text>to</Text>
                                            <Menu>
                                                <MenuButton
                                                    p="8px"
                                                    transition='all 0.2s'
                                                    borderRadius='sm'
                                                    borderWidth='1px'
                                                    fontSize="12px"
                                                    fontWeight="500"
                                                    bg="white"
                                                    as={Button}
                                                    rightIcon={<ChevronDownIcon />}>
                                                    5
                                                </MenuButton>
                                                <MenuList>
                                                    <MenuItem>10</MenuItem>
                                                </MenuList>
                                            </Menu>

                                        </HStack>
                                        <HStack fontSize="12px" width="54%">
                                            <Text>1.</Text>
                                            <Input variant='filled' placeholder='Horrible' />
                                        </HStack>
                                        <HStack fontSize="12px" width="54%">
                                            <Text>5.</Text>
                                            <Input variant='filled' placeholder='Excellent' />
                                        </HStack>
                                    </Stack>
                                    <Box>
                                        <Image src={combine_ratio} alt="Test Graph"/>
                                    </Box>
                                </Flex>
                                <Divider mt="1.4rem" borderColor="#9E9E9E" borderWidth="0.1px"/>
                            </Box>
                            <Box width="80%" height="auto" mt="1rem"  px="3rem" py="1.4rem">
                                <HStack spacing="8px">
                                    <Text>1.    The entire training programme delivery and arrangement met my expectation</Text>
                                </HStack>
                                <Flex justifyContent="space-between" mt="1.6rem">
                                    <Stack spacing="14px">
                                        <HStack spacing="1.4rem">
                                            <Menu>
                                                <MenuButton
                                                    p="8px"
                                                    transition='all 0.2s'
                                                    borderRadius='sm'
                                                    borderWidth='1px'
                                                    fontSize="12px"
                                                    fontWeight="500"
                                                    bg="white"
                                                    as={Button}
                                                    rightIcon={<ChevronDownIcon />}>
                                                    1
                                                </MenuButton>
                                                <MenuList>
                                                    <MenuItem>0</MenuItem>
                                                </MenuList>
                                            </Menu>
                                            <Text>to</Text>
                                            <Menu>
                                                <MenuButton
                                                    p="8px"
                                                    transition='all 0.2s'
                                                    borderRadius='sm'
                                                    borderWidth='1px'
                                                    fontSize="12px"
                                                    fontWeight="500"
                                                    bg="white"
                                                    as={Button}
                                                    rightIcon={<ChevronDownIcon />}>
                                                    5
                                                </MenuButton>
                                                <MenuList>
                                                    <MenuItem>10</MenuItem>
                                                </MenuList>
                                            </Menu>

                                        </HStack>
                                        <HStack fontSize="12px" width="54%">
                                            <Text>1.</Text>
                                            <Input variant='filled' placeholder='Horrible' />
                                        </HStack>
                                        <HStack fontSize="12px" width="54%">
                                            <Text>5.</Text>
                                            <Input variant='filled' placeholder='Excellent' />
                                        </HStack>
                                    </Stack>
                                    <Box>
                                        <Image src={combine_ratio} alt="Test Graph"/>
                                    </Box>
                                </Flex>
                                <Divider mt="1.4rem" borderColor="#9E9E9E" borderWidth="0.1px"/>
                            </Box>
                            <Box width="80%" height="auto" mt="1rem"  px="3rem" py="1.4rem">
                                <HStack spacing="8px">
                                    <Text>1.    The entire training programme delivery and arrangement met my expectation</Text>
                                </HStack>
                                <Flex justifyContent="space-between" mt="1.6rem">
                                    <Stack spacing="14px">
                                        <HStack spacing="1.4rem">
                                            <Menu>
                                                <MenuButton
                                                    p="8px"
                                                    transition='all 0.2s'
                                                    borderRadius='sm'
                                                    borderWidth='1px'
                                                    fontSize="12px"
                                                    fontWeight="500"
                                                    bg="white"
                                                    as={Button}
                                                    rightIcon={<ChevronDownIcon />}>
                                                    1
                                                </MenuButton>
                                                <MenuList>
                                                    <MenuItem>0</MenuItem>
                                                </MenuList>
                                            </Menu>
                                            <Text>to</Text>
                                            <Menu>
                                                <MenuButton
                                                    p="8px"
                                                    transition='all 0.2s'
                                                    borderRadius='sm'
                                                    borderWidth='1px'
                                                    fontSize="12px"
                                                    fontWeight="500"
                                                    bg="white"
                                                    as={Button}
                                                    rightIcon={<ChevronDownIcon />}>
                                                    5
                                                </MenuButton>
                                                <MenuList>
                                                    <MenuItem>10</MenuItem>
                                                </MenuList>
                                            </Menu>

                                        </HStack>
                                        <HStack fontSize="12px" width="54%">
                                            <Text>1.</Text>
                                            <Input variant='filled' placeholder='Horrible' />
                                        </HStack>
                                        <HStack fontSize="12px" width="54%">
                                            <Text>5.</Text>
                                            <Input variant='filled' placeholder='Excellent' />
                                        </HStack>
                                    </Stack>
                                    <Box>
                                        <Image src={combine_ratio} alt="Test Graph"/>
                                    </Box>
                                </Flex>
                                <Divider mt="1.4rem" borderColor="#9E9E9E" borderWidth="0.1px"/>
                            </Box>
                            <Box width="80%" height="auto" mt="1rem"  px="3rem" py="1.4rem">
                                <HStack spacing="8px">
                                    <Text>1.    The entire training programme delivery and arrangement met my expectation</Text>
                                </HStack>
                                <Flex justifyContent="space-between" mt="1.6rem">
                                    <Stack spacing="14px">
                                        <HStack spacing="1.4rem">
                                            <Menu>
                                                <MenuButton
                                                    p="8px"
                                                    transition='all 0.2s'
                                                    borderRadius='sm'
                                                    borderWidth='1px'
                                                    fontSize="12px"
                                                    fontWeight="500"
                                                    bg="white"
                                                    as={Button}
                                                    rightIcon={<ChevronDownIcon />}>
                                                    1
                                                </MenuButton>
                                                <MenuList>
                                                    <MenuItem>0</MenuItem>
                                                </MenuList>
                                            </Menu>
                                            <Text>to</Text>
                                            <Menu>
                                                <MenuButton
                                                    p="8px"
                                                    transition='all 0.2s'
                                                    borderRadius='sm'
                                                    borderWidth='1px'
                                                    fontSize="12px"
                                                    fontWeight="500"
                                                    bg="white"
                                                    as={Button}
                                                    rightIcon={<ChevronDownIcon />}>
                                                    5
                                                </MenuButton>
                                                <MenuList>
                                                    <MenuItem>10</MenuItem>
                                                </MenuList>
                                            </Menu>

                                        </HStack>
                                        <HStack fontSize="12px" width="54%">
                                            <Text>1.</Text>
                                            <Input variant='filled' placeholder='Horrible' />
                                        </HStack>
                                        <HStack fontSize="12px" width="54%">
                                            <Text>5.</Text>
                                            <Input variant='filled' placeholder='Excellent' />
                                        </HStack>
                                    </Stack>
                                    <Box>
                                        <Image src={combine_ratio} alt="Test Graph"/>
                                    </Box>
                                </Flex>
                                <Divider mt="1.4rem" borderColor="#9E9E9E" borderWidth="0.1px"/>
                            </Box>
                        </VStack>

                    </TabPanel> */}
                    </TabPanels>
                </Tabs>
            </Center>
        </>
    )
}
    export default CreateSurvey